import React from "react"
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  SelectChangeEvent,
  MenuItem,
} from "@mui/material"
import { selectBankAccounts, setFilters } from "../../slices/bankAccountsSlice"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { RefreshRounded } from "@mui/icons-material"
import { PrimaryButton, StyledButton } from "../Transactions/styles"

interface FiltersProps {
  ResetFilterHandler: () => void
  ApplyFilterHandler: () => void
}

const Filters: React.FC<FiltersProps> = ({
  ApplyFilterHandler,
  ResetFilterHandler,
}) => {
  const dispatch = useAppDispatch()
  const {
    filters,
    isBankNamesLoading,
    bankNames,
    paymentModes,
    isPaymentModesLoading,
  } = useAppSelector(selectBankAccounts)
  return (
    <Box
      sx={{
        display: "flex",
        columnGap: 3,
        rowGap: 2,
        flexDirection: "column",
        width: "100%",
      }}
    >
      <FormControl size="small">
        <InputLabel id="select-bank-name">Bank Name</InputLabel>
        <Select
          labelId="select-bank-name"
          id="selectBankName"
          label="Bank Name"
          value={filters.bankName}
          onChange={(e: SelectChangeEvent) =>
            dispatch(
              setFilters({
                ...filters,
                bankName: e.target.value as string,
              }),
            )
          }
          disabled={!isBankNamesLoading}
        >
          <MenuItem value="all">All</MenuItem>
          {bankNames.map((bank) => (
            <MenuItem key={bank.id} value={bank.id}>
              {bank.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small">
        <InputLabel id="select-payment-mode">Payment Mode</InputLabel>
        <Select
          labelId="select-payment-mode"
          id="selectPaymentMode"
          label="Payment Mode"
          value={filters.paymentMode}
          onChange={(e: SelectChangeEvent) =>
            dispatch(
              setFilters({
                ...filters,
                paymentMode: e.target.value as string,
              }),
            )
          }
          disabled={!isPaymentModesLoading}
        >
          <MenuItem value="all">All</MenuItem>
          {paymentModes.map((mode) => (
            <MenuItem key={mode.id} value={mode.id}>
              {mode.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small">
        <InputLabel id="select-source">Source</InputLabel>
        <Select
          labelId="select-source"
          id="selectSource"
          label="Source"
          value={filters.source}
          onChange={(e: SelectChangeEvent) =>
            dispatch(
              setFilters({
                ...filters,
                source: e.target.value as string,
              }),
            )
          }
        >
          <MenuItem value="alts">Alts</MenuItem>
          <MenuItem value="workspace">Workspace</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small">
        <InputLabel id="select-invoice-source">Invoice Source</InputLabel>
        <Select
          labelId="select-invoice-source"
          id="selectInvoiceSource"
          label="Invoice Source"
          value={filters.invoiceSource}
          onChange={(e: SelectChangeEvent) =>
            dispatch(
              setFilters({
                ...filters,
                invoiceSource: e.target.value as string,
              }),
            )
          }
        >
          <MenuItem value="tusker">Tusker</MenuItem>
          <MenuItem value="zenith">Zenith</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small">
        <InputLabel id="select-is-active">Is Active</InputLabel>
        <Select
          labelId="select-is-active"
          id="selectIsActive"
          label="Is Active"
          value={filters.isActive}
          onChange={(e: SelectChangeEvent) =>
            dispatch(
              setFilters({
                ...filters,
                isActive: e.target.value as string,
              }),
            )
          }
        >
          <MenuItem value="yes">Yes</MenuItem>
          <MenuItem value="no">No</MenuItem>
        </Select>
      </FormControl>
      <Box sx={{ display: "flex", gap: "10px", flex: 1 }}>
        <StyledButton
          sx={{ width: "100%" }}
          variant="outlined"
          startIcon={<RefreshRounded fontSize="small" />}
          color="inherit"
          onClick={ResetFilterHandler}
        >
          Reset
        </StyledButton>
        <PrimaryButton
          sx={{ width: "100%" }}
          variant="contained"
          onClick={ApplyFilterHandler}
        >
          Apply
        </PrimaryButton>
      </Box>
    </Box>
  )
}

export default Filters
